











































































































































import { computed, defineComponent, ref, getCurrentInstance } from '@vue/composition-api';
import { DeleteIcon, RootListIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
import { fileLocationHandler } from '@/renderer/views/desktop/FileManagement/RelatedToMe/composition/fileLocationHandler';
import sensitiveListHandler from './composition/listHandler';
import AddSensitiveWord from './component/AddSensitiveWord.vue';
export default defineComponent({
  components: {
    RootListIcon,
    DeleteIcon,
    AddSensitiveWord,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    const enableAntivirus = ref(false);
    const tooltipVisible = ref(false);
    const hoverBtn = ref(false);
    const virusMap = [
      {
        title: i18n_t('全盘病毒识别'),
        icon: 'security-scan-distinguish',
      },
      {
        title: i18n_t('上传拦截防御'),
        icon: 'security-scan-defense',
      },
      {
        title: i18n_t('文件安全隔离'),
        icon: 'security-scan-quarantine',
      },
    ];
    const showAddWordDialog = ref(false);
    const enableManageAntivirus = computed(() => store.getters.enableManageAntivirus);
    const { methods: fileLocationMethods } = fileLocationHandler();
    const {
      columns,
      tableData,
      showListDrawer,
      drawerData,
      chooseWord,
      methods: listMethods,
      loading,
    } = sensitiveListHandler();
    const methods = {
      onVisibleChange(visible: boolean) {
        tooltipVisible.value = visible;
      },
      async getConfig() {
        if (!enableManageAntivirus.value) return;
        try {
          tips.loading(i18n_t('正在获取安全配置信息'));
          const res = await smh.userAPI.getSecurityScanConfig();
          tips.closeAll();
          enableAntivirus.value = res.data.enableAntivirus;
        } catch (e) {
          tips.error(i18n_t('获取安全配置信息失败'));
        }
      },
      async setConfig(isOpen: boolean) {
        try {
          tips.loading(i18n_t('正在修改安全配置信息'));
          reporter.report('security_scan', {
            security_scan: Number(isOpen),
          });
          await smh.userAPI.setSecurityScanConfig({
            enableAntivirus: isOpen,
          });
          // 请求成功之后修改结果
          enableAntivirus.value = isOpen;
          store.commit('SET_ENABLE_ANTIVIRUS', isOpen);
          tips.closeAll();
        } catch (error) {
          tips.error(error as MsgError);
        }
      },
      async goFileAddress(item: SMH.SensitiveWordData) {
        const tempPath = item.path;
        if (item.inRecycledDirectory) {
          tips.error(i18n_t('该文件已被移至误删恢复，请在误删恢复中查找。'));
          return;
        }
        if (!item.inDirectory || !tempPath) {
          tips.error(i18n_t('该文件已被彻底删除，无法查看。'));
          return;
        }
        if (!item.inDirectoryGroup && item.spaceTag === 'group') {
          tips.error(i18n_t('当前无该协作群组权限，请联系群主或文件创建者添加权限。'));
          return;
        }
        try {
          // 发送请求判断文件是否加白或者被删除
          const options = {
            path: item.path.join('/'),
            spaceId: item.spaceId,
            spaceOrgId: store.getters.orgId,
          };
          const { data } = await smh.userAPI.getDirectoryOrFileInfo(options);
          if (!data.inDirectory || !data.path) {
            tips.error(i18n_t('该文件已被彻底删除，无法查看。'));
          } else {
            if (data.sensitiveWordAuditStatus === 3) {
              tips.warning(i18n_t('该文件已被列为信任文件。'));
            }
            const path = item.type === 'dir' ? item.path.join('/') : item.path?.slice(0, -1)?.join('/');
            // 对方的群组
            if (item?.spaceTag === 'group') {
              const isExternal = item.group.orgId !== store.getters.orgId;
              store.commit(DrawerEvents.SET_SELECTEDLIST, [
                {
                  ...item.group,
                  ownerId: item.group?.userId,
                },
              ]);
              fileLocationMethods.toGroup({
                spaceId: item.spaceId,
                name: item.group.name,
                spaceOrgId: item.group.orgId,
                groupId: item.group.id,
                id: item.group.id,
                isExternal: `${+isExternal}`,
                path,
              });
            } else if (item?.spaceTag === 'team') {
              fileLocationMethods.toTeamSpace({
                teamPath: item.team?.path?.join('/') || item.team?.name,
                spaceId: item.team.spaceId,
                teamId: item.team.id,
                path,
              });
            }
          }
        } catch (err: MsgError) {
          tips.error(err);
        }
      },
    };
    methods.getConfig();
    return {
      tooltipVisible,
      hoverBtn,
      enableAntivirus,
      virusMap,
      columns,
      tableData,
      loading,
      showAddWordDialog,
      showListDrawer,
      drawerData,
      chooseWord,
      enableManageAntivirus,
      ...listMethods,
      ...methods,
    };
  },
});
